import iconThemeColor from "../index";

const ContentCopyIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 3.5C15.7761 3.5 16 3.72386 16 4C16 4.27614 15.7761 4.5 15.5 4.5H7.5C6.67157 4.5 6 5.17157 6 6V17C6 17.2761 5.77614 17.5 5.5 17.5C5.22386 17.5 5 17.2761 5 17V6C5 4.61929 6.11929 3.5 7.5 3.5H15.5ZM16 6C17.3807 6 18.5 7.11929 18.5 8.5V17.5C18.5 18.8807 17.3807 20 16 20H10C8.61929 20 7.5 18.8807 7.5 17.5V8.5C7.5 7.11929 8.61929 6 10 6H16ZM17.5 8.5C17.5 7.67157 16.8284 7 16 7H10C9.17157 7 8.5 7.67157 8.5 8.5V17.5C8.5 18.3284 9.17157 19 10 19H16C16.8284 19 17.5 18.3284 17.5 17.5V8.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CheckCircleIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9161 10.2774C15.0692 10.0476 15.0071 9.7372 14.7774 9.58403C14.5476 9.43085 14.2372 9.49294 14.084 9.7227L11.3772 13.7829L9.80003 12.6001C9.57912 12.4344 9.26571 12.4791 9.10003 12.7001C8.93434 12.921 8.97912 13.2344 9.20003 13.4001L11.2 14.9001C11.31 14.9825 11.449 15.0161 11.5844 14.9929C11.7199 14.9697 11.8398 14.8917 11.9161 14.7774L14.9161 10.2774Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ResetIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8536 3.64645C14.0488 3.84171 14.0488 4.15829 13.8536 4.35355L12.6727 5.53439C15.9465 5.871 18.5 8.6373 18.5 12C18.5 15.2212 16.1573 17.8943 13.0827 18.4102C12.8104 18.4558 12.5526 18.2721 12.5069 17.9998C12.4612 17.7274 12.6449 17.4696 12.9173 17.4239C15.5181 16.9876 17.5 14.7247 17.5 12C17.5 9.21997 15.4374 6.92168 12.7591 6.55195L13.8536 7.64645C14.0488 7.84171 14.0488 8.15829 13.8536 8.35355C13.6583 8.54882 13.3417 8.54882 13.1464 8.35355L11.1464 6.35355C10.9512 6.15829 10.9512 5.84171 11.1464 5.64645L13.1464 3.64645C13.3417 3.45118 13.6583 3.45118 13.8536 3.64645Z"
        fill={fillColor}
      />
      <path
        d="M9.25036 7.2355C9.48939 7.09723 9.57107 6.79136 9.4328 6.55233C9.29453 6.3133 8.98867 6.23162 8.74964 6.36989C6.80809 7.49302 5.5 9.59345 5.5 12C5.5 15.2212 7.8427 17.8943 10.9173 18.4102C11.1896 18.4558 11.4474 18.2721 11.4931 17.9998C11.5388 17.7274 11.3551 17.4696 11.0827 17.4239C8.48187 16.9876 6.5 14.7248 6.5 12C6.5 9.96485 7.6051 8.18723 9.25036 7.2355Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CloneIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 19C14.8807 19 16 17.8807 16 16.5V16H16.5C17.8807 16 19 14.8807 19 13.5V7.5C19 6.11929 17.8807 5 16.5 5H10.5C9.11929 5 8 6.11929 8 7.5V8H7.5C6.11929 8 5 9.11929 5 10.5V16.5C5 17.8807 6.11929 19 7.5 19H13.5ZM8 9H7.5C6.67157 9 6 9.67157 6 10.5V16.5C6 17.3284 6.67157 18 7.5 18H13.5C14.3284 18 15 17.3284 15 16.5V16H10.5C9.11929 16 8 14.8807 8 13.5V9ZM16.5 15C17.3284 15 18 14.3284 18 13.5V7.5C18 6.67157 17.3284 6 16.5 6H10.5C9.67157 6 9 6.67157 9 7.5V13.5C9 14.3284 9.67157 15 10.5 15H16.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const FilterIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.63365 8.12111C3.60277 7.20477 4.25092 5.5 5.6302 5.5H18.3698C19.7491 5.5 20.3972 7.20477 19.3663 8.12111L15.1678 11.8531C15.0611 11.948 15 12.084 15 12.2268V18C15 18.8284 14.3284 19.5 13.5 19.5H10.5C9.67159 19.5 9.00001 18.8284 9.00001 18V12.2269C9.00001 12.084 8.93894 11.948 8.83219 11.8532L4.63365 8.12111ZM5.6302 6.5C5.17044 6.5 4.95439 7.06826 5.29801 7.37371L9.49656 11.1057C9.81679 11.3904 10 11.7984 10 12.2269V18C10 18.2761 10.2239 18.5 10.5 18.5H13.5C13.7762 18.5 14 18.2761 14 18V12.2268C14 11.7984 14.1832 11.3904 14.5035 11.1057L18.702 7.3737C19.0456 7.06826 18.8296 6.5 18.3698 6.5H5.6302Z"
        fill={fillColor}
      />
    </svg>
  );
};

const SearchIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C11.3387 15.5 12.5658 15.0217 13.5195 14.2266L17.6465 18.3536C17.8417 18.5489 18.1583 18.5489 18.3536 18.3536C18.5489 18.1583 18.5489 17.8417 18.3536 17.6465L14.2266 13.5195C15.0217 12.5658 15.5 11.3387 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5ZM5.5 10C5.5 7.51472 7.51472 5.5 10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10Z"
        fill={fillColor}
      />
    </svg>
  );
};

const LogsIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5C7.17157 5 6.5 5.67157 6.5 6.5V17.5C6.5 18.3284 7.17157 19 8 19H16C16.8284 19 17.5 18.3284 17.5 17.5V9.5H14C12.6193 9.5 11.5 8.38071 11.5 7V5H8ZM12.5 5.5L16.5 8.5H14C13.1716 8.5 12.5 7.82843 12.5 7V5.5ZM5.5 6.5C5.5 5.11929 6.61929 4 8 4H12C12.1082 4 12.2135 4.03509 12.3 4.1L18.3 8.6C18.4259 8.69443 18.5 8.84262 18.5 9V17.5C18.5 18.8807 17.3807 20 16 20H8C6.61929 20 5.5 18.8807 5.5 17.5V6.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CurlyBracesIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 6.07789V5C8.21964 5 7.31653 5 6.57782 5.34632C6.17887 5.68526 5.895 6.0807 5.72622 6.53263C5.56255 6.97965 5.48071 7.46105 5.48071 7.97684V9.49474C5.48071 9.99579 5.36563 10.3937 5.13547 10.6884C4.9053 10.9832 4.52682 11.1305 4 11.1305V12.42C4.3478 12.42 4.62911 12.4888 4.84393 12.6263C5.06386 12.7589 5.22497 12.9481 5.32727 13.1937C5.42956 13.4344 5.48071 13.7242 5.48071 14.0632V15.5663C5.48071 16.0821 5.56255 16.5635 5.72622 17.0105C5.895 17.4625 6.17887 17.8579 6.57782 18.1968C6.97676 18.5407 7.52404 18.8084 8.21964 19L8.5879 17.9832C8.2401 17.8653 7.9639 17.6884 7.75932 17.4526C7.55984 17.2168 7.41663 16.9368 7.32968 16.6126C7.24784 16.2933 7.20693 15.9446 7.20693 15.5663V14.0632C7.20693 13.5621 7.09696 13.1126 6.87703 12.7147C6.66775 12.3223 6.33713 12.0092 5.88514 11.7753C6.33713 11.5414 6.66775 11.2282 6.87703 10.8358C7.09696 10.433 7.20693 9.98597 7.20693 9.49474V7.97684C7.20693 7.41193 7.30411 6.91088 7.49847 6.47368C7.64621 6.14987 8.19678 6.12614 8.62205 6.10781C8.77095 6.1014 8.90449 6.09564 9 6.07789Z"
        fill={fillColor}
      />
      <path
        d="M15 6.07789V5C15.7804 5 16.6835 5 17.4222 5.34632C17.8211 5.68526 18.105 6.0807 18.2738 6.53263C18.4375 6.97965 18.5193 7.46105 18.5193 7.97684V9.49474C18.5193 9.99579 18.6344 10.3937 18.8645 10.6884C19.0947 10.9832 19.4732 11.1305 20 11.1305V12.42C19.6522 12.42 19.3709 12.4888 19.1561 12.6263C18.9361 12.7589 18.775 12.9481 18.6727 13.1937C18.5704 13.4344 18.5193 13.7242 18.5193 14.0632V15.5663C18.5193 16.0821 18.4375 16.5635 18.2738 17.0105C18.105 17.4625 17.8211 17.8579 17.4222 18.1968C17.0232 18.5407 16.476 18.8084 15.7804 19L15.4121 17.9832C15.7599 17.8653 16.0361 17.6884 16.2407 17.4526C16.4402 17.2168 16.5834 16.9368 16.6703 16.6126C16.7522 16.2933 16.7931 15.9446 16.7931 15.5663V14.0632C16.7931 13.5621 16.903 13.1126 17.123 12.7147C17.3322 12.3223 17.6629 12.0092 18.1149 11.7753C17.6629 11.5414 17.3322 11.2282 17.123 10.8358C16.903 10.433 16.7931 9.98597 16.7931 9.49474V7.97684C16.7931 7.41193 16.6959 6.91088 16.5015 6.47368C16.3538 6.14987 15.8032 6.12614 15.378 6.10781C15.229 6.1014 15.0955 6.09564 15 6.07789Z"
        fill={fillColor}
      />
    </svg>
  );
};

const PlayArrowIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5.86852C7 4.67048 8.33522 3.95589 9.33205 4.62044L18.5293 10.7519C19.4199 11.3457 19.4199 12.6543 18.5293 13.2481L9.33205 19.3796C8.33522 20.0441 7 19.3295 7 18.1315V5.86852ZM8.77735 5.45249C8.44507 5.23098 8 5.46917 8 5.86852V18.1315C8 18.5308 8.44507 18.769 8.77735 18.5475L17.9746 12.416C18.2714 12.2181 18.2714 11.7819 17.9746 11.584L8.77735 5.45249Z"
        fill={fillColor}
      />
    </svg>
  );
};

const UndoIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 18.5C17.7239 18.5 17.5 18.2761 17.5 18V16C17.5 14.067 15.933 12.5 14 12.5H7.20711L9.35355 14.6464C9.54882 14.8417 9.54882 15.1583 9.35355 15.3536C9.15829 15.5488 8.84171 15.5488 8.64645 15.3536L5.64645 12.3536C5.45118 12.1583 5.45118 11.8417 5.64645 11.6464L8.64645 8.64645C8.84171 8.45118 9.15829 8.45118 9.35355 8.64645C9.54882 8.84171 9.54882 9.15829 9.35355 9.35355L7.20711 11.5H14C16.4853 11.5 18.5 13.5147 18.5 16V18C18.5 18.2761 18.2761 18.5 18 18.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const RedoIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 18.5C6.27614 18.5 6.5 18.2761 6.5 18V16C6.5 14.067 8.067 12.5 10 12.5H16.7929L14.6464 14.6464C14.4512 14.8417 14.4512 15.1583 14.6464 15.3536C14.8417 15.5488 15.1583 15.5488 15.3536 15.3536L18.3536 12.3536C18.5488 12.1583 18.5488 11.8417 18.3536 11.6464L15.3536 8.64645C15.1583 8.45118 14.8417 8.45118 14.6464 8.64645C14.4512 8.84171 14.4512 9.15829 14.6464 9.35355L16.7929 11.5H10C7.51472 11.5 5.5 13.5147 5.5 16V18C5.5 18.2761 5.72386 18.5 6 18.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CutIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C8.20914 2 10 3.79086 10 6C10 7.17538 9.49274 8.23203 8.68555 8.96387L10.3115 10.3643L18 4H21.5L8.68555 15.0361C9.49274 15.768 10 16.8246 10 18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18C2 15.8179 3.74722 14.0441 5.91895 14.001L8.33594 11.999L5.91895 9.99902C3.74722 9.95586 2 8.18206 2 6C2 3.79086 3.79086 2 6 2ZM6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16ZM6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4Z"
        fill={fillColor}
      />
      <path d="M21.5 20H18L11.5918 14.6953L13.3721 13L21.5 20Z" fill={fillColor} />
    </svg>
  );
};

const StopIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 9.5C9.72386 9.5 9.5 9.72386 9.5 10V14C9.5 14.2761 9.72386 14.5 10 14.5H14C14.2761 14.5 14.5 14.2761 14.5 14V10C14.5 9.72386 14.2761 9.5 14 9.5H10Z"
        fill="#7443FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill="#7443FF"
      />
    </svg>
  );
};

export const ThemedContentCopyIcon = iconThemeColor(ContentCopyIcon);
export const ThemedResetIcon = iconThemeColor(ResetIcon);
export const ThemedCloneIcon = iconThemeColor(CloneIcon);
export const ThemedFilterIcon = iconThemeColor(FilterIcon);
export const ThemedSearchIcon = iconThemeColor(SearchIcon);
export const ThemedLogsIcon = iconThemeColor(LogsIcon);
export const ThemedCurlyBracesIcon = iconThemeColor(CurlyBracesIcon);
export const ThemedPlayArrowIcon = iconThemeColor(PlayArrowIcon);
export const ThemedUndoIcon = iconThemeColor(UndoIcon);
export const ThemedRedoIcon = iconThemeColor(RedoIcon);
export const ThemedCheckCircleIcon = iconThemeColor(CheckCircleIcon);
export const ThemedCutIcon = iconThemeColor(CutIcon);
export const ThemedStopIcon = iconThemeColor(StopIcon);
